import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements, ActionMenuOption } from 'ui/actionMenu/types';
import { ProjectsActionButtonProps } from '../types';

export const ProjectsActionButton = ({
  openArchiveModal,
  openEditModal,
  openUnarchiveModal,
  project,
}: ProjectsActionButtonProps) => {
  const editId = 'edit-project';
  const archiveId = 'archive-project';

  const canArchive = !project.extendedProjectSettings.isArchived;
  const archiveOnClick = canArchive ? openArchiveModal : openUnarchiveModal;
  const archiveLabel = canArchive ? 'Archive project' : 'Unarchive project';

  const options: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <span>Edit project</span>
        </>
      ),
      id: editId,
      onClick: () => openEditModal(project),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <span>{archiveLabel}</span>
        </>
      ),
      id: archiveId,
      onClick: () => archiveOnClick(project),
    },
  ];

  return (
    <OverflowMenu
      id="projects-table-overflow-menu"
      data-test="projects-table-actions-button"
      options={options}
    />
  );
};
